import { ColumnSortConfig } from "../../pages/UnifiedReminderPage/types/sortTypes";

export const COLUMN_CONFIGS: ColumnSortConfig[] = [
  {
    field: "willBeReadyFrom",
    label: "Dospeće terapije",
    sortable: true,
    defaultDirection: "asc",
  },
  {
    field: "userFirstName",
    label: "Ime i prezime pacijenta",
    sortable: true,
    defaultDirection: "asc",
  },

  {
    field: "therapyTaken",
    label: "Terapija preuzeta",
    sortable: true,
    defaultDirection: "desc",
  },
  {
    field: "status",
    label: "Status",
    sortable: true,
    defaultDirection: "asc",
  },
];

// Helper to find column config
export const findColumnConfig = (
  field: string
): ColumnSortConfig | undefined => {
  return COLUMN_CONFIGS.find((c) => c.field === field);
};
